<template>
  <div>
    <countdown-book />
    <div v-if="paymentList.length > 0 && !loadingPaymentList" class="choose-payment py-3">
      <b-form-group>
        <b-form-radio
          v-for="(payMethod, index) in paymentList"
          :key="index"
          v-model="selectedPaymentIndex"
          name="some-radios"
          :value="index"
          :class="(compareString(payMethod.Type, paymentType.PAYMENT_TYPE_VA_BCA) && isDisabledVA) || (compareString(payMethod.Type, paymentType.PAYMENT_TYPE_MIDTRANS) && useYesdokBalance) ? 'disabled-payment' : ''"
          :disabled="compareString(payMethod.Type, paymentType.PAYMENT_TYPE_VA_BCA) && isDisabledVA || compareString(payMethod.Type, paymentType.PAYMENT_TYPE_MIDTRANS) && useYesdokBalance"
          @change.native="selectedPayment(selectedPaymentIndex, payMethod.Balance, payMethod)"
        >
          <span class="d-flex flex-row align-items-center text-premier-blue w-100 position-relative">
            <div class="float-left" :class="(compareString(payMethod.Type, paymentType.PAYMENT_TYPE_VA_BCA) && isDisabledVA) ? 'disable-icon-va' : ''">
              <template v-if="compareString(payMethod.Type, paymentType.PAYMENT_TYPE_VA_BCA)">
                <img width="50px" class="mr-2" src="@/assets/icon/icon-bca.png" alt="">
              </template>
              <template v-else-if="payMethod.paymentType === cardType">
                <img
                  width="50px"
                  :src="payMethod.Type.toLowerCase() === 'mastercard' ? require('@/assets/img/mastercard.png') : require('@/assets/img/visa.png')"
                  class="mr-2 pt-1"
                  alt=""
                  style="height: 40px;"
                >
              </template>
              <template v-else>
                <img width="50px" class="mr-2" :src="payMethod.ImageUrl" alt="">
              </template>
            </div>
            <!-- <div class="float-left pl-2" :class="(compareString(payMethod.Type, paymentType.PAYMENT_TYPE_VA_BCA) && isShowCountdownTimer) ? 'pt-2' : (compareString(payMethod.Type, paymentType.PAYMENT_TYPE_CC)) ? 'pt-2' : (compareString(payMethod.Type, paymentType.PAYMENT_TYPE_OVO)) ? 'pt-3' : (compareString(payMethod.Type, paymentType.PAYMENT_TYPE_VA_BCA) && !isShowCountdownTimer) ? 'pt-3' : 'pt-2'" :style="(compareString(payMethod.Type, paymentType.PAYMENT_TYPE_VA_BCA) && isDisabledVA) ? 'color: #0246684a' : ''"> -->
            <div class="float float-left pl-2">
              <span class="font-rubik-medium text">
                {{ payMethod.paymentType === cardType ? payMethod.Type : payMethod.paymentType === 'midtrans' ? 'Metode Pembayaran Lain' : payMethod.Name }}
              </span><br>
              <span v-if="compareString(payMethod.Type, paymentType.PAYMENT_TYPE_VA_BCA) && isShowCountdownTimer" class="font-rubik-medium countdownVA">Lakukan pembayaran dalam: {{ hour }}:{{ minute }}:{{ second }}
              </span>
              <span v-if="(compareString(payMethod.Type, paymentType.PAYMENT_TYPE_DANA) || compareString(payMethod.Type, paymentType.PAYMENT_TYPE_LINKAJA)) && !payMethod.Balance" class="text-premier-blue regular-font">
                Hubungkan
              </span>
              <div
                v-if="payMethod.paymentType === 'midtrans'"
              >
                <img
                  v-for="(image, idx) in payMethod.PaymentCooperation"
                  :key="idx"
                  :src="image"
                  class="mr-2"
                  alt=""
                  width="50px"
                >
              </div>
              <span v-if="payMethod.Balance || payMethod.Balance === 0" class="mr-5 text-premier-blue regular-font">
                Rp {{ payMethod.Balance | formatMoney }}
              </span>
              <span v-if="payMethod.paymentType === cardType" class="text-premier-blue regular-font">
                **** **** **** {{ payMethod.LastFourDigits }}
              </span>
            </div>
            <div v-if="compareString(payMethod.Type, paymentType.PAYMENT_TYPE_VA_BCA)">
              <div v-if="isActive" class="box-info-countdown">
                <p class="mb-0 text-white">
                  Metode VA sudah tidak dapat digunakan, silahkan pilih metode lain
                </p>
                <b-button
                  class="px-4 mt-3 text-white"
                  @click="onShow"
                >
                  Mengerti
                </b-button>
              </div>
              <div v-if="isDisabledVA" class="box-icon-info">
                <img src="@/assets/icon/icon-info-i-green.svg" @click="onShow">
              </div>
            </div>
            <div v-if="compareString(payMethod.Type, paymentType.PAYMENT_TYPE_MIDTRANS) && useYesdokBalance" style="position: absolute; right: -5px; z-index: 20;">
              <el-tooltip class="item" effect="light" content="Metode pembayaran Midtrans tidak bisa digunakan bersamaan dengan Saldo Yesdok" placement="bottom-end">
                <img src="@/assets/icon/guard-warning.svg" alt="warn icon" width="30px">
              </el-tooltip>
            </div>
          </span>
        </b-form-radio>
      </b-form-group>
      <div class="box-button">
        <b-button
          class="m-auto bg-white text-premier-blue text-center"
          size="lg"
          block
          @click="$bvModal.show('addCreditCardModal')">
          <img class="pb-1" src="@/assets/icon/icon-plus.svg" alt="">
          <span class="font-rubik-medium">Tambah Kartu Kredit</span>
        </b-button>
      </div>
    </div>
    <div v-else class="text-center text-premier-blue my-5">
      <b-spinner label="Spinner" />
    </div>
    <b-modal
      id="addCreditCardModal"
      title="Tambahkan Kartu Kredit"
      hide-footer
      centered
      header-class="border-0"
      title-class=""
      content-class="border-radius-20px"
      @hide="resetPayment()"
    >
      <form method="POST" :action="BASE_YD_URL + 'SpR1nt/CreditCardPayment'" @submit="submitCC">
        <input type="hidden" name="token" :value="formCC.token">
        <input type="hidden" name="cardNo" :value="formCC.cardNoOnlyNumber">
        <input type="hidden" name="cardExpMonth" :value="formCC.cardExp.split('/')[0]">
        <input type="hidden" name="cardExpYear" :value="`${$moment().format('YYYY').slice(0, 2)}${formCC.cardExp.split('/')[1]}`">
        <input type="hidden" name="cardType" :value="cardBrand">
        <input type="hidden" name="billingName" :value="formCC.billingName">
        <input type="hidden" name="billingAddress" :value="formCC.billingAddress">
        <input type="hidden" name="billingCountry" :value="formCC.billingCountry">
        <input type="hidden" name="billingState" :value="formCC.billingState">
        <input type="hidden" name="billingPhone" :value="formCC.phone_formatted">
        <input type="hidden" name="billingPostalCode" :value="formCC.billingPostalCode">
        <input type="hidden" name="billingEmail" :value="formCC.billingEmail">
        <input type="hidden" name="YesDokCallback" :value="formCC.YesDokCallback">
        <input type="hidden" name="YesDokErrorCallback" :value="formCC.YesDokErrorCallback">

        <div class="form-group">
          <label for="nocc">No. Kartu Kredit</label>
          <input
            id="nocc"
            v-model.trim="$v.formCC.cardNo.$model"
            v-cardformat:formatCardNumber
            v-mask="'####-####-####-####'"
            type="text"
            class="form-control"
            placeholder="No. Kartu Kredit"
            maxlength="19"
          >
          <small v-if="$v.formCC.cardNo.$dirty && !$v.formCC.cardNo.required" class="text-danger">Field is required</small>
        </div>
        <div class="form-row">
          <div class="form-group col-md-9">
            <label for="expire">Tanggal Kadaluarsa</label>
            <input
              id="expire"
              v-model.trim="$v.formCC.cardExp.$model"
              v-mask="ccExpMask"
              type="text"
              class="form-control"
              placeholder="Tanggal Kadaluarsa"
            >
            <small v-if="$v.formCC.cardExp.$dirty && !$v.formCC.cardExp.required" class="text-danger">Field is required
              <br></small>
            <small class="text">Ex: 06/20</small>
          </div>
          <div class="form-group col-md-3">
            <label for="cvv">CVV</label>
            <input
              id="cvv"
              v-model.trim="$v.formCC.cardCVV.$model"
              v-cardformat:formatCardCVC
              v-mask="'####'"
              type="password"
              class="form-control"
              name="cardSecurity"
              placeholder="CVV"
            >
            <small v-if="$v.formCC.cardCVV.$dirty && !$v.formCC.cardCVV.required" class="text-danger">Field is required</small>
          </div>
        </div>
        <div class="form-group">
          <label for="cardname">Nama pada Kartu</label>
          <input id="cardname" v-model.trim="$v.formCC.billingName.$model" type="text" class="form-control" placeholder="Nama pada Kartu">
          <small v-if="$v.formCC.billingName.$dirty && !$v.formCC.billingName.required" class="text-danger">Field is required</small>
        </div>
        <div class="form-group">
          <label for="address">Alamat</label>
          <input id="address" v-model.trim="$v.formCC.billingAddress.$model" type="text" class="form-control" placeholder="Alamat">
          <small v-if="$v.formCC.billingAddress.$dirty && !$v.formCC.billingAddress.required" class="text-danger">Field is required</small>
        </div>
        <div class="form-group">
          <label>Negara</label>
          <el-select
            id="country"
            v-model.trim="$v.formCC.billingCountry.$model"
            :popper-class="'max-option'"
            style="width: 100%"
            autocomplete="off"
            class="select-filtered"
            filterable
            placeholder="Pilih Negara"
            @change="setProvince"
          >
            <el-option
              v-for="(item, index) in countries"
              :key="index"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
          <small v-if="$v.formCC.billingCountry.$dirty && !$v.formCC.billingCountry.required" class="text-danger">Field is required</small>
        </div>
        <div class="form-group">
          <label>Provinsi</label>
          <el-select
            id="province"
            v-model.trim="$v.formCC.billingState.$model"
            style="width: 100%"
            autocomplete="off"
            filterable
            class="select-filtered"
            placeholder="Pilih Provinsi"
            @change="setCity"
          >
            <el-option
              v-for="(province, index) in filteredProvinces"
              :key="index"
              :label="province"
              :value="province"
            />
          </el-select>
          <small v-if="$v.formCC.billingState.$dirty && !$v.formCC.billingState.required" class="text-danger">Field is required</small>
        </div>
        <div class="form-group">
          <label>Kota</label>
          <el-select
            id="city"
            v-model.trim="$v.formCC.billingCity.$model"
            autocomplete="off"
            filterable
            placeholder="Pilih Kota"
            class="w-100 select-filtered"
          >
            <el-option
              v-for="(city, index) in filteredCities"
              :key="index"
              :label="city"
              :value="city"
            />
          </el-select>
          <small v-if="$v.formCC.billingCity.$dirty && !$v.formCC.billingCity.required" class="text-danger">Field is required</small>
        </div>
        <div class="form-group">
          <label for="postal">Kode POS</label>
          <input id="postal" v-model.trim="$v.formCC.billingPostalCode.$model" type="number" class="form-control mask_number_only" placeholder="Kode POS">
          <small v-if="$v.formCC.billingPostalCode.$dirty && !$v.formCC.billingPostalCode.required" class="text-danger">Field is required</small>
        </div>
        <div class="form-group">
          <label for="phone">Nomor Telepon</label>
          <input id="phone" v-model="$v.formCC.phone_formatted.$model" type="text" class="form-control w-100" placeholder="Nomor Telepon">
          <small v-if="$v.formCC.phone_formatted.$dirty && !$v.formCC.phone_formatted.required" class="text-danger">Field is required</small>
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input id="email" v-model="$v.formCC.billingEmail.$model" type="email" class="form-control w-100" placeholder="Email">
          <small v-if="$v.formCC.billingEmail.$dirty && (!$v.formCC.billingEmail.required || !$v.formCC.billingEmail.email)" class="text-danger">Field is required</small>
        </div>
        <div class="row">
          <div class="col-12 text-center my-3">
            <b-button
              block
              variant="primary-3"
              size="lg"
              class="mb-4 mt-3 border-r25px overflow-hidden position-relative"
              type="submit"
              :disabled="formCC.loading"
            >
              <div v-if="formCC.loading" class="spinner-box position-absolute">
                <b-spinner label="Spinner" class="spinner-submit" />
              </div>
              Simpan
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
    <div id="modal-list-appointment" class="modal modal-timeout max-w-600 mx-auto">
      <div class="modal-content modal-list">
        <div class="popup-header text-center">
          <img src="@/assets/icon/sad-icon.svg">
          <h2 class="text-uppercase mt-3 mb-4">Jadwal dokter sudah tidak tersedia</h2>
          <p class="mb-3">Silahkan pilih di waktu yang tersedia</p>
        </div>
        <div class="modal-body">
          <calendar-picker v-if="showListAppointment" :data-select="dataSelect" class="bg-soft-grey" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import country from 'assets/json/country.json'
import state from 'assets/json/state.json'
import city from 'assets/json/city.json'
import _ from 'lodash'
import { required, email } from 'vuelidate/lib/validators'
import CalendarPicker from '@/components/appointment-component/CalendarPicker'
import CountdownBook from '@/components/appointment-component/CountdownBook'
import handleStatus from '~/mixins/handleStatus.js'
export default {
  name: 'ListPayments',
  components: {
    CalendarPicker,
    CountdownBook
  },
  mixins: [handleStatus],
  data: () => ({
    showListAppointment: false,
    dataSelect: {
      priceSelect: '',
      durationSelect: '',
      durationConversation: '',
      durationReview: ''
    },
    hour: '00',
    minute: '00',
    second: '00',
    isShowCountdownTimer: false,
    isDisabledVA: false,
    isActive: false,
    BASE_YD_URL: process.env.BASE_YD_URL,
    loadingPaymentList: false,
    paymentList: [],
    countries: country,
    filteredProvinces: [],
    filteredCities: [],
    selectedPaymentIndex: null,
    ccExpMask: [/\d/, /\d/, '/', /\d/, /\d/],
    cardType: 'creditcard',
    cardBrand: null,
    formCC: {
      loading: false,
      token: localStorage.getItem('token'),
      cardNoOnlyNumber: '',
      cardNo: '',
      cardExp: '',
      cardCVV: '',
      billingName: '',
      billingAddress: '',
      billingCountry: null,
      billingState: null,
      billingCity: null,
      billingPostalCode: '',
      billingPhone: '',
      phone_formatted: '',
      billingEmail: '',
      YesDokCallback: encodeURI(window.location.href),
      YesDokErrorCallback: encodeURI(window.location.href)
    }
  }),
  validations: {
    formCC: {
      cardNo: {
        required
      },
      cardExp: {
        required
      },
      cardCVV: {
        required
      },
      billingName: {
        required
      },
      billingAddress: {
        required
      },
      billingCountry: {
        required
      },
      billingState: {
        required
      },
      billingCity: {
        required
      },
      billingPostalCode: {
        required
      },
      phone_formatted: {
        required
      },
      billingEmail: {
        required, email
      }
    }
  },
  computed: {
    checkCountdown () {
      return this.$store.state.doctor.countdownOff
    },
    appointmentBook () {
      return this.$store.state.doctor.appointmentBook
    },
    selectedAppointment () {
      return this.$store.state.doctor.booking.selectedAppointment
    },
    selectPaymentIndex () {
      return this.$store.state.doctor.selectedPaymentIndex
    },
    isDisableVA () {
      return this.$store.state.patient.disableVA
    },
    paymentType () {
      return this.$store.state.paymentType
    },
    useYesdokBalance () {
      return this.$store.state.doctor.useYesdokBalance
    }
  },
  watch: {
    checkCountdown: {
      handler (value) {
        if (value) {
          this.showModalList('block')
        } else {
          this.showModalList('none')
        }
      }
    },
    'formCC.cardNo' () {
      this.formCC.cardNoOnlyNumber = this.formCC.cardNo.replace(/\D/g, '')
    }
  },
  mounted () {
    this.getPaymentList()
    if (this.selectPaymentIndex !== null) {
      this.selectedPaymentIndex = this.selectPaymentIndex
    }
    if (this.isDisableVA) {
      this.isDisabledVA = true
    }
  },
  methods: {
    showModalList (val) {
      this.showListAppointment = true
      this.dataSelect.priceSelect = this.selectedAppointment.Price
      this.dataSelect.durationSelect = this.selectedAppointment.ConsultLength
      this.dataSelect.durationConversation = this.selectedAppointment.ConversationTime
      this.dataSelect.durationReview = this.selectedAppointment.ReviewTime
      const modal = document.getElementById('modal-list-appointment')
      modal.style.display = val
    },
    onShow () {
      this.isActive = !this.isActive
    },
    timerCountdown (duration) {
      let timer = duration
      this.timerInterval = setInterval(() => {
        const seconds = timer % 60
        const secondsInMinutes = (timer - seconds) / 60
        const minutes = secondsInMinutes % 60
        const hours = (secondsInMinutes - minutes) / 60
        this.hour = String(hours).padStart(2, '0')
        this.minute = String(minutes).padStart(2, '0')
        this.second = String(seconds).padStart(2, '0')
        if (hours === 0 && minutes < 30) {
          this.isShowCountdownTimer = true
        }
        --timer
        if (minutes === 0 && seconds < 1) {
          this.isDisabledVA = true
          clearInterval(this.timerInterval)
        }
      }, 1000)
    },
    getPaymentList () {
      this.$store.dispatch('patient/getPaymentList')
        .then((res) => {
          if (res.Emoneys) {
            res.Emoneys.forEach((emoneys) => {
              this.paymentList.push(Object.assign(emoneys, {
                paymentType: 'emoney'
              }))
            })
          }

          if (res.VirtualAccount) {
            this.paymentList.push(res.VirtualAccount)
          }

          if (res.CreditCards) {
            res.CreditCards.forEach((cc) => {
              this.paymentList.push(Object.assign(cc, {
                paymentType: 'creditcard'
              }))
            })
          }

          if (res.Midtrans) {
            this.paymentList.push(Object.assign(res.Midtrans, { paymentType: 'midtrans' }))
          }

          if (res.VirtualAccount) {
            this.timerCountdown(res.VirtualAccount.CountDownLeft)
          }
        })
        .catch((err) => {
          if (err.response.data.Message === 'TNC_CONFIRMATION') {
            this.$swal({
              width: 500,
              padding: '3em',
              allowOutsideClick: false,
              title: 'Pembaruan Syarat dan Ketentuan',
              html:
                '<p>Kami telah memperbarui syarat dan ketentuan berlaku.</p>' +
                `<a href="${this.BASE_YD_URL}${this.$store.state.patient.auth.userData.Language === 'ID' ? 'id' : 'en'}/tnc.html" class="my-2" target="_blank">Klik untuk membaca</a>` +
                '<hr class="mt-4">',
              input: 'checkbox',
              inputValue: 0,
              inputPlaceholder: 'Saya telah membaca dan setuju dengan <b>syarat dan ketentuan</b> yang berlaku',
              confirmButtonText: 'SETUJU',
              inputValidator: (result) => {
                return !result && 'Anda harus setuju dengan T&C'
              },
              customClass: {
                container: 'alert-tnc',
                actions: 'flex-nowrap w-full',
                validationMessage: 'ml-1 mr-1',
                confirmButton: 'w-full mt-4 py-3 bg-blue-primary btn-next',
                title: 'px-0 text-uppercase titlePopup'
              },
              preConfirm: () => {
                return this.$store.dispatch('patient/acceptTnc')
                  .then((response) => {
                    this.getPaymentList()
                  })
                  .catch((err) => {
                    throw new Error(err)
                  })
              }
            })
          } else {
            throw new Error(err)
          }
        })
    },
    selectedPayment (index, balance, payMethod) {
      const data = {
        index,
        balance
      }
      if (this.compareString(payMethod.Type, this.paymentType.PAYMENT_TYPE_LINKAJA) || this.compareString(payMethod.Type, this.paymentType.PAYMENT_TYPE_DANA)) {
        if (payMethod.Balance == null || typeof payMethod.Balance === 'undefined') {
          // TODO soon add payment loading
          this.selectedPaymentIndex = index
          this.selectedLinkLogin = payMethod.LoginUrl
          setTimeout(() => {
            if (process.client) {
              window.location.href = this.selectedLinkLogin
            }
          }, 1000)
        } else {
          this.setPayment(data)
        }
      } else {
        this.setPayment(data)
      }
    },
    setPayment (data) {
      clearInterval(this.timerInterval)
      this.selectedPaymentIndex = data.index
      this.$store.commit('doctor/SET_PAYMENT_INDEX', data.index)
      this.$store.commit('doctor/SET_BALANCE', data.balance === null ? 'undefined' : data.balance)
      this.$store.commit('doctor/SET_PAYMENT', this.paymentList[data.index])
      this.$store.commit('doctor/SET_STEP', 'confirmation')
      localStorage.setItem('step', 'confirmation')
    },
    setProvince () {
      const self = this
      const selected = _.find(self.countries, ['code', self.formCC.billingCountry])
      if (selected) { self.filteredProvinces = state[selected.name] }
    },
    setCity () {
      const self = this
      const selected = this.formCC.billingState
      if (selected) { self.filteredCities = city[selected] }
    },
    resetPayment () {
      this.checkoutLoading = false
      // reset cc
      this.formCC.billingName = ''
      this.formCC.billingState = null
      this.formCC.billingCountry = null
      this.formCC.billingCity = null
      this.formCC.cardExp = ''
      this.formCC.cardCVV = ''
      this.formCC.cardNo = ''
      this.formCC.billingEmail = ''
      this.formCC.billingPhone = ''
      this.formCC.billingPostalCode = ''
      this.formCC.billingAddress = ''
      this.$v.formCC.$reset()
    },
    submitCC (e) {
      this.$v.$touch()
      if (!this.$v.$invalid && this.cardBrand !== 'unknown') {
        this.formCC.loading = true
        return true
      }
      if (this.cardBrand === 'unknown') {
        this.$swal('Gagal Menambahkan Kartu Kredit', 'Nomor kartu kredit anda salah!', 'error')
      }
      e.preventDefault()
    }
  }
}
</script>

<style scoped lang="scss">
  .box-info-countdown {
    right: 0;
    top: -130px;
    background: #00C300;
    &::after {
      right: 5px;
      bottom: -16px;
      border-color: #00C300 transparent transparent transparent;
    }
  }
</style>

<style lang="scss">
  .spinner-box {
    left: 0;
    right: 0;
    span {
      width: 23px;
      height: 23px;
    }
  }
  .regular-font {
    font-size: 14px;
  }
  .box-button {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 65px;
    button {
      border: 1px solid #024668;
      text-align: left;
      padding-top: 10px;
      position: relative;
      border-radius: 10px;
      padding-bottom: 10px;
      margin: 0px !important;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
      &:hover, &:active, &:focus {
        box-shadow: none;
        color: #024668 !important;
      }
      .arrow-bottom {
        position: absolute;
        right: 15px;
        top: 30px;
      }
    }
  }
  .choose-payment {
    .custom-control {
      display: flex;
      min-height: 54px;
      padding: 0px 15px;
      align-items: center;
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 10px;
      margin-left: 10px !important;
      margin-right: 10px !important;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
      .custom-control-label {
        width: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        padding: 1rem 0;
        &::before {
          top: 50%;
          left: unset !important;
          right: 0 !important;
          transform: translate(0, -50%);
          border: 2px solid #7c7c7c !important;
          width: 1.3rem !important;
          height: 1.3rem !important;
        }
        &::after {
          left: unset !important;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
          width: 1.3rem !important;
          height: 1.3rem !important;
          background-image: unset !important;
          cursor: pointer;
        }
      }
    }
    .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
      background-color: #00B5E2 !important;
      box-shadow: inset 0 0 0 1px #fff;
    }
    .custom-control-input:checked ~ .custom-control-label::before {
      border-color: #00B5E2 !important;
      background-color: #00B5E2 !important;
      box-shadow: inset 0 0 0 1px #fff;
    }
  }
  .boxCountdown {
    color: #ffffff;
    font-size: 15px;
    padding: 10px 5px;
    background: #024668;
  }
  .countdownVA {
    color: #FF0000;
    font-size: 14px;
  }
  .disabled-payment {
    opacity: 0.5;
    background: #bdbdbd66 !important;
  }
  .box-icon-info {
    top: 15px;
    right: -1px;
    z-index: 999;
    position: absolute;
    @media screen and (max-width: 485px) {
      top: 13px;
      right: -2px;
    }
    img {
      width: 24px;
      cursor: pointer;
    }
  }
  .box-info-countdown {
    width: 330px;
    z-index: 999;
    padding: 15px;
    border-radius: 8px;
    position: absolute;
    @media screen and (max-width: 485px) {
      top: -120px;
    }
    button {
      border-radius: 8px;
      background: #024668;
      border: 1px solid #024668;
      &:hover {
        background: #024668;
      }
    }
    &::after {
      content: "";
      position: absolute;
      border-width: 8px;
      border-style: solid;
    }
  }
  .alert-tnc {
    .swal2-popup {
      border-radius: 25px;
      .swal2-header {
        padding: 0px;
        .titlePopup {
          color: #014668;
          font-size: 23px !important;
        }
      }
      .swal2-content {
        padding: 0px;
        p {
          font-size: 17px;
          margin: 8px 0px 25px 0px;
        }
        a {
          color: #014668;
          font-size: 17px;
          text-decoration: underline;
        }
        hr {
          height: 1px;
          background: #dddddd;
        }
        span {
          &.swal2-label {
            font-size: 14px;
            text-align: left;
          }
        }
        .swal2-validation-message {
          font-size: 16px;
          margin: 0px !important;
          &::before {
            width: 1.4em;
            height: 1.4em;
            font-size: 14px;
            min-width: 1.4em;
          }
        }
      }
      .swal2-actions {
        button {
          width: 100%;
          height: 45px;
          padding: 0px;
          font-size: 16px;
          line-height: 13px;
          background: #014668;
          margin: 0px !important;
        }
      }
    }
  }
</style>
